import {scan} from 'rxjs/operators';
import {adlData$} from '@/raw/adl';
import type {ws} from '@/types';
type ContractADLRaw = ws.ContractADLRaw;

export const adlCache$ = adlData$.pipe(
  scan((p, c) => {
    const {posSide = '', symbol} = c;
    const key = posSide ? symbol + posSide : symbol;
    p.set(key, c);
    return p;
  }, new Map<string, ContractADLRaw>())
);
